module.exports = __webpack_public_path__ + "img/买茶送小黄鸭电器.911e659c.png";